// Single source of truth for clinic data. Staff can edit these values later.
export const clinicConfig = {
  name: "West Virginia Family Medicine",
  shortName: "WV Family Medicine",
  doctor: "Dr. Andres Rago",
  doctorTitle: "Family Medicine Physician",
  experience: "Over 30 years of experience",
  experienceYears: "30+",
  tagline: "Primary care for southern West Virginia, in person and online.",
  address: "135 W Main Street, Keystone, WV 24868",
  addressLine1: "135 W Main Street",
  addressLine2: "Keystone, WV 24868",
  phoneDisplay: "(828) 738-2277",
  phoneTel: "+18287382277",
  mapUrl:
    "https://www.google.com/maps/search/?api=1&query=135+W+Main+Street+Keystone+WV+24868",
  hours: {
    timezone: "America/New_York",
    days: [1, 2, 3, 4], // Mon-Thu
    daysLabel: "Monday – Thursday",
    open: "09:00",
    close: "17:00",
    openLabel: "9:00 AM",
    closeLabel: "5:00 PM",
  },
  // Primary conversion target. Swap to a backend auth endpoint later without touching components.
  patientPortalUrl: "https://doctok.co/patient",
};
